import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { todayStr, dueDay } from '../../../utils/followUpDates';

export const FollowUpForm = ({ initial, submitLabel = 'Set Reminder', resetOnSuccess = false, onSubmit, onCancel }) => {
  const [day, setDay] = useState(initial ? dueDay(initial.due_date) : '');
  const [note, setNote] = useState(initial?.note || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    if (!day) {
      setError('Choose a date for this follow-up.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await onSubmit({ day, note });
      if (resetOnSuccess) {
        setDay('');
        setNote('');
      }
    } catch (err) {
      setError(err.message || 'Could not save the follow-up.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <Input
        type="date"
        value={day}
        onChange={(e) => setDay(e.target.value)}
        min={initial ? undefined : todayStr()}
      />
      <Input
        placeholder="What is this follow-up for? (e.g., Send proposal)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        maxLength={500}
      />
      {error && <p className="text-sm font-medium text-red-600">{error}</p>}
      <div className="flex gap-2">
        <Button type="submit" variant="secondary" size="sm" className="flex-1" isLoading={submitting} disabled={!day}>
          {submitLabel}
        </Button>
        {onCancel && (
          <Button type="button" variant="ghost" size="sm" onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
        )}
      </div>
    </form>
  );
};